import React from 'react';
export function MaintenanceCostsSection() {
  return <section data-id="element-3234">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3235">
        <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-3236">
          3. Maintenance Costs
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3237">
        <p data-id="element-3238">
          Although maintenance budgets are usually incorporated into operating
          costs, the authors say they may not be accurately reflected in machine
          ROI calculations. Maintenance means downtime, and repairs usually mean
          unscheduled downtime, but the authors also astutely note that
          maintenance issues can affect a machine's productivity well before it
          finally goes down for repairs.
        </p>
        <p data-id="element-3239">
          For example, the authors present a hypothetical scenario in which a
          ballscrew needs to be replaced. The shop must see to the costs of the
          part and its installation, scrapped parts, unplanned downtime and
          overtime to catch back up. But that ballscrew didn't fail all at once.
          "The machine was likely declining in performance before anyone
          realized what went wrong," they write. That gradual failure could also
          easily reduce part quality.
        </p>
      </div>
    </section>;
}